import {
  useState,
  useEffect,
  useRef,
} from 'react';
import PropTypes, { oneOfType } from 'prop-types';

const LazyLoad = ({
  children,
  observerOptions,
}) => {
  const [visible, setVisible] = useState(false);
  const childNode = useRef([]);
  const lazyLoadRef = (el) => { childNode.current = el; };
  useEffect(
    () => {
      const observerCallback = (entries, self) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setVisible(true);
            self.unobserve(entry.target);
          }
        });
      };
      let observer = null;
      /**
       * Se il client non supporta IntersectionObserver
       * non tentiamo di istanziarlo e settiamo subito la visibilità a true
       */
      if (window && 'IntersectionObserver' in window) {
        observer = new window.IntersectionObserver(observerCallback, observerOptions);
        observer.observe(childNode.current);
      } else {
        setVisible(true);
      }
      /**
       * Quando il componente viene smontato, 'spegniamo' l'observer 
       * se presente
       */
      return () => {
        if (observer) {
          observer.disconnect();
        }
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [],
  );
  return children(visible, lazyLoadRef);
};
LazyLoad.propTypes = {
  children: oneOfType([
    PropTypes.func,
    PropTypes.object,
    PropTypes.string,
    PropTypes.node,
  ]),
  observerOptions: PropTypes.instanceOf(Object),
};
LazyLoad.defaultProps = {
  children: null,
  observerOptions: {
    rootMargin: '0px',
    threshold: 0
  },
};
export default LazyLoad;

